// extracted by mini-css-extract-plugin
module.exports = {"search":"styles-module--search--epruK","open":"styles-module--open--1oGnl","results":"styles-module--results--3LjS1"};